import type { CommentItem } from './comments-types'
import { apiConfig } from "./client";

export const commentApi = {
  list: async (replied: string, page: number, size: number, signal?: AbortSignal) => {
    const response = await apiConfig.get<CommentItem[]>(
      `/api/front/chef/comments/${replied}/${page}/${size}`,
      { signal }
    );
    return response;
  },
  reply: async (orderId: string, repliedComment: string) => {
    const response = await apiConfig.post(`/api/front/chef/reply-comment`, {
      repliedComment: repliedComment,
      orderId: orderId,
    });
    return response;
  },
};
